import classNames from 'classnames';
import { IconStarFilled } from '@/features/icons';
import { ceilToDecimal } from '@/utils/ceil-to-decimal';
import usePDPData from '../../_utils/use-pdp-data';
interface Props {
  className?: string;
  isLinkToCommentSection?: boolean;
}
function StarRate({
  className,
  isLinkToCommentSection = false
}: Props) {
  const {
    rate,
    ratesCount
  } = usePDPData().data || {};
  if (!ratesCount || ratesCount < 3) return null;
  const handleScrollToComments = () => {
    if (!isLinkToCommentSection) return;
    const commentsOffset = document.getElementById('comments')?.offsetTop;
    if (!commentsOffset) return;
    window.scrollTo({
      behavior: 'smooth',
      top: commentsOffset - 20
    });
  };
  return <button type='button' onClick={handleScrollToComments} className={classNames('flex items-center gap-1 lg:gap-1.5', {
    'cursor-default': !isLinkToCommentSection
  }, className)} data-sentry-component="StarRate" data-sentry-source-file="star-rate.tsx">
            <IconStarFilled className='h-4 w-4 text-alert-warning-dark lg:h-5 lg:w-5' data-sentry-element="IconStarFilled" data-sentry-source-file="star-rate.tsx" />
            <span className='text-caption-12 text-text-mediumGray lg:text-body-14'>
                {ceilToDecimal(rate || 0)} امتیاز
            </span>
        </button>;
}
export default StarRate;